<app-navbar></app-navbar>
<app-news-admin></app-news-admin>
<app-videos-admin></app-videos-admin>
<app-admin-concerts></app-admin-concerts>
<app-admin-pro></app-admin-pro>
